import { Configuration, PopupRequest } from '@azure/msal-browser';

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    authority:
      'https://prpservicerportal.ciamlogin.com/f5d940b1-6ce6-46f3-8733-a78996abbc31',
    clientId: '9f3815bd-458f-4e5e-af11-ae0dc047a61f',
    navigateToLoginRequestUrl: true,
    postLogoutRedirectUri: window.location.origin,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest: PopupRequest = {
  scopes: ['User.Read'],
};
